export default "__VITE_ASSET__DyUXemiE__"